import PersonIcon from "@material-ui/icons/Person";
import PersonList from "./PersonList";
import PersonCreate from "./PersonCreate";
import PersonEdit from "./PersonEdit";
import PersonShow from "./PersonShow";

export default {
  list: PersonList,
  create: PersonCreate,
  edit: PersonEdit,
  show: PersonShow,
  icon: PersonIcon,
};
